import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import {
  ChatContainer,
  MessageList,
  MessageBubble,
  AvatarWrapper,
  StyledImage,
  InputContainer,
  StyledTextField,
  SendButton,
  SendButtonImage,
  DottedLoader,
} from '../styles/ChatWindow';
import Footer from '../components/Footer';
import { addUserMessage, setInput, resetInput, sendMessage } from '../store/ChatReducer';
import SendIcon from '../assets/images/svg/send-icon.png';
import connitLogo from '../assets/images/logo/logo.png';
import LogoutPopup from './LogoutPopup';

const INACTIVITY_TIMEOUT = 15000; // 10 minutes

const ChatWindow = ({ onFirstMessage, onLogout }) => {
  const dispatch = useDispatch();
  const { messages, input, isBotTyping } = useSelector((state) => state.chat);
  const [isLogoutPopupVisible, setIsLogoutPopupVisible] = useState(false);

  useEffect(() => {
    let timeout;
  
    const handleUserActivity = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsLogoutPopupVisible(true);
        console.log('Inactivity detected, showing popup'); // Debug log
      }, INACTIVITY_TIMEOUT);
    };
  
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keypress', handleUserActivity);
  
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keypress', handleUserActivity);
    };
  }, []);
  

  const handleSend = () => {
    const trimmedInput = input.trim();
    if (!trimmedInput) return;

    if (messages.length === 0) {
      onFirstMessage();
    }

    dispatch(addUserMessage(trimmedInput));
    dispatch(resetInput());
    dispatch(sendMessage(trimmedInput));
  };

  const handleLogout = () => {
    setIsLogoutPopupVisible(false);
    onLogout();
  };

  const handleDismissPopup = () => {
    setIsLogoutPopupVisible(false);
  };

  const renderMessages = () =>
    messages.map((msg, index) => (
      <Box key={index} display="flex" justifyContent={msg.sender === 'user' ? 'flex-end' : 'flex-start'}>
        {msg.sender === 'bot' && (
          <AvatarWrapper sender="bot">
            <StyledImage src={connitLogo} alt="Connit Labs Logo" />
          </AvatarWrapper>
        )}
        <MessageBubble sender={msg.sender}>
          <Typography variant="body1">{msg.text}</Typography>
        </MessageBubble>
        {msg.sender === 'user' && <AvatarWrapper sender="user">S</AvatarWrapper>}
      </Box>
    ));

  return (
    <ChatContainer>
      <MessageList>
        {renderMessages()}
        {isBotTyping && (
          <Box display="flex" justifyContent="flex-start" alignItems="center" mb={2}>
            <AvatarWrapper sender="bot">G</AvatarWrapper>
            <DottedLoader>
              <span></span>
              <span></span>
              <span></span>
            </DottedLoader>
          </Box>
        )}
      </MessageList>

      <InputContainer>
        <StyledTextField
          fullWidth
          variant="outlined"
          value={input}
          onChange={(e) => dispatch(setInput(e.target.value))}
          onKeyDown={(e) => e.key === 'Enter' && handleSend()}
          placeholder="Message Genie"
        />
        <SendButton onClick={handleSend}>
          <SendButtonImage src={SendIcon} alt="Send" />
        </SendButton>
      </InputContainer>

      {isLogoutPopupVisible && <LogoutPopup onLogout={handleLogout} onDismiss={handleDismissPopup} />}

      <Footer />
    </ChatContainer>
  );
};

export default ChatWindow;
